import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { getRoutes } from '../routes';
import { Error } from './Error';

const renderRoutes = (routes) => {
  return Object.entries(routes).map(([key, route]) => {
    const { path, component: Component, children, exact = true } = route;
    return (
      <Route
        key={key}
        path={path}
        exact={exact}
        element={<Component />}
      >
        {children && Array.isArray(children)
          ? children.map((child, idx) => (
            <Route
              key={`${key}-child-${idx}`}
              path={child.path}
              exact={child.exact ?? true}
              element={<child.component />}
            />
          ))
          : null}
      </Route>
    );
  });
};

const ServicesOnline = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {renderRoutes(routes)}
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
};

ServicesOnline.propTypes = {
  serverPages: PropTypes.shape({})
};

ServicesOnline.defaultProps = {
  serverPages: {}
};

export default ServicesOnline;